module.exports = __webpack_public_path__ + "static/img/9.b6344bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/sp/9.png
// module id = 00jt
// module chunks = 0